// Cookie constants
export const TOOLBAR_COOKIE_NAME = 'flipdish_toolbar_disabled';
export const COOKIE_EXPIRY_DAYS = 365;

// MFE Configuration
export interface MFEConfig {
  windowName: string;
}

export const availableMFEs: MFEConfig[] = [
  { windowName: 'marketing' },
  { windowName: 'finance' },
  { windowName: 'menu-editor' },
  { windowName: 'menu-editor-v3' },
  { windowName: 'restaurant-menus' },
  { windowName: 'property-management' },
  { windowName: 'qrop' },
  { windowName: 'admin-tools-micro-frontend' },
  { windowName: 'onboarding-internal-tools' },
  { windowName: 'clients-onboarding' },
  { windowName: 'webhook-service' },
  { windowName: 'subscriptions' },
  { windowName: 'restaurant-layout-designer' },
  { windowName: 'fpm-mf' },
  { windowName: 'mobile-apps-tools' },
  { windowName: 'communication' },
  { windowName: 'authorization' },
  { windowName: 'serverless-app-template' },
];

// MFE override URL helper
export const getMfeOverrideUrl = (windowName: string): string | null => {
  const raw = localStorage.getItem(windowName);
  if (raw === null) return null;

  // JSON format written by mfeStorage: { url, expiresAt? }
  let urlCandidate = raw;
  try {
    const json = JSON.parse(raw);
    if (json && typeof json === 'object' && typeof json.url === 'string') {
      if (json.expiresAt !== undefined && new Date(json.expiresAt) <= new Date()) {
        localStorage.removeItem(windowName);
        return null;
      }
      urlCandidate = json.url;
    }
  } catch {
    // not JSON — fall through and treat raw value as a plain URL string
  }

  try {
    const parsed = new URL(urlCandidate);
    if (['http:', 'https:'].includes(parsed.protocol) && parsed.hostname) {
      return urlCandidate;
    }
    localStorage.removeItem(windowName);
    return null;
  } catch {
    localStorage.removeItem(windowName);
    return null;
  }
};

// Cookie functions
export const setCookie = (name: string, value: string, days: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const domain = window.location.hostname;
  document.cookie = `${name}=${value};${expires};domain=${domain};path=/`;
};

export const getCookie = (name: string): string | null => {
  const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`));

  return cookie ? cookie.trim().substring(name.length + 1) : null;
};
